<template>
    <popup size="custom" @codd_close="$emit('close')">
        <div class="popup-share" :class="{mobile: device === 'mobile'}">
            <div class="d-flex justify-content-between align-items-center">
                <span class="title">{{ $t('powerpack.imageContainer.popupShare.shareLink') }}</span>
                <span class="close" @click="$emit('close')">&times;</span>
            </div>
            <div class="build-container">
              <template v-if="shareLink">
                  <div class="share-qr">
                      <qrcode-vue :value="shareLink" />
                  </div>
                  <div class="share-link">
                      <input readonly :value="shareLink" class="share-input" @click="copyToClipboard" ref="shareLink" />
                      <img src="../../assets/copy.png" alt="copy" class="copy-img" @click="copyToClipboard">
                      <transition name="fade" mode="out-in">
                          <span :key="copyText" class="copy-text" @click="copyToClipboard">{{copyText}}</span>
                      </transition>
                  </div>
              </template>
              <span v-if="!shareLink">{{ $t('powerpack.imageContainer.popupShare.notAvailable') }}</span>
            </div>
        </div>
    </popup>
</template>

<script>
  import { mapGetters } from "vuex"
  import Popup from "./Popup";
  import QrcodeVue from 'qrcode.vue'

  export default {
    name: "PopupShare",

    data() {
      return {
        copyText: this.$t('powerpack.imageContainer.popupShare.copyLink')
      }
    },

    computed: {
      ...mapGetters({
        device: 'getDevice',
      }),
    },

    components: {
      Popup,
      QrcodeVue
    },

    props: {
      shareLink: String,
    },

    methods: {
      copyToClipboard() {
        this.copyText = this.$t('powerpack.imageContainer.popupShare.copiedLink')
        let Url = this.$refs.shareLink;
        Url.innerHTML = window.location.href;
        Url.select();
        document.execCommand("copy");

        this.$nextTick(() => {
          setTimeout(() => {
            this.copyText = this.$t('powerpack.imageContainer.popupShare.copyLink')
          }, 4000);
        })
      }
    },
  }
</script>

<style scoped lang="scss">
    .fade-enter-active,
    .fade-leave-active {
        transition: opacity 100ms ease;
    }

    .fade-enter,
    .fade-leave-to {
        opacity: 0;
    }

    .popup-share {
        width: 688px;
        padding: 22px 24px;

        &.mobile {
            width: 100%;
        }

        .title {
            font-size: 20px;
            font-family: neue-haas-grotesk-display, sans-serif;
            font-weight: 700;
            color: #3C3C3B;
        }

        .close {
            font-size: 40px;
            transition: all ease 0.3s;
            position: relative;
            color: #A4AFB7;
            opacity: 1;
            text-shadow: none;
            font-weight: 100;
            cursor: pointer;

            &:hover {
                color: darken(#A4AFB7, 60%);
            }
        }

        .build-container {
            margin-top: 12px;
            display: flex;
            flex-direction: column;
            align-items: center;

            >div {
                margin-bottom: 25px;
            }
        }

        .share-input {
            width: 425px;
            cursor: pointer;
        }

        .copy-img {
            width: 22px;
            height: 22px;
            margin-left: 5px;
            cursor: pointer;
        }

        .copy-text {
            transition: all ease 0.3s;
            margin-left: 5px;
            font-size: 0.8rem;
            cursor: pointer;
        }
    }
</style>
